import styled from 'styled-components'

export const Wrapper = styled.div`
  .small-btn {
    transform: scale(0.8);
    margin: -0.8%;
  }
`
export const ReplayButton = styled.div`
  cursor: pointer;
  color: var(--second-color);
  font-size: 1.5rem;
  margin-left: auto;
  &:hover {
    opacity: 0.8;
  }
`
